import { render } from "./privacityView.vue?vue&type=template&id=1fef9788&scoped=true"
import script from "./privacityView.vue?vue&type=script&lang=js"
export * from "./privacityView.vue?vue&type=script&lang=js"

import "./privacityView.vue?vue&type=style&index=0&id=1fef9788&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fef9788"]])

export default __exports__